import { render, staticRenderFns } from "./talentDetail.vue?vue&type=template&id=b125edbe&scoped=true&"
import script from "./talentDetail.vue?vue&type=script&lang=ts&"
export * from "./talentDetail.vue?vue&type=script&lang=ts&"
import style0 from "./talentDetail.vue?vue&type=style&index=0&id=b125edbe&lang=scss&scoped=true&"
import style1 from "./talentDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b125edbe",
  null
  
)

export default component.exports